export const noRowsTemplate = {
  template: `
    <div>
        <svg
    id="orderhistory_icon"
    xmlns="http://www.w3.org/2000/svg"
    width="74"
    height="74"
    viewBox="0 0 74 74"
  >
    <path id="Path_1383" data-name="Path 1383" d="M0,0H74V74H0Z" fill="none" />
    <path
      id="Path_1384"
      data-name="Path 1384"
      d="M15,3V9.167"
      transform="translate(31.25 6.25)"
      fill="none"
      stroke="#bbb"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_1385"
      data-name="Path 1385"
      d="M7,3V9.167"
      transform="translate(14.583 6.25)"
      fill="none"
      stroke="#bbb"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_1386"
      data-name="Path 1386"
      d="M3,9H52.333"
      transform="translate(6.25 18.75)"
      fill="none"
      stroke="#bbb"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_1387"
      data-name="Path 1387"
      d="M52.333,22.5V13.25A9.249,9.249,0,0,0,43.083,4H12.25A9.249,9.249,0,0,0,3,13.25V41a9.249,9.249,0,0,0,9.25,9.25H24.583"
      transform="translate(6.25 8.333)"
      fill="none"
      stroke="#bbb"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_1388"
      data-name="Path 1388"
      d="M17.393,15.983V21.4L21.654,24"
      transform="translate(36.235 33.298)"
      fill="none"
      stroke="#bbb"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_1389"
      data-name="Path 1389"
      d="M26.875,40.75A13.874,13.874,0,0,1,13,26.875,14.087,14.087,0,0,1,26.887,13a13.875,13.875,0,0,1-.012,27.75"
      transform="translate(27.083 27.083)"
      fill="none"
      stroke="#bbb"
      stroke-width="1.5"
    />
  </svg>
<!--      <p class="font-Regular-14" style="color:#BBBBBB;">هیچ تراکنشی ندارید</p>-->
    </div>`
};
